import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_LISTS',
    icon: 'ServerIcon',
    action: constants.action.permissionDebtCaseView,
    resource: constants.resource.debtCase,
    children: [
      {
        title: 'DEBTIA_TASK_LIST',
        route: 'task-list',
        action: 'company',
        resource: 'company',
      },
      {
        title: 'DEBTIA_FILTER_LIST',
        route: 'filter-list',
        action: constants.action.permissionFilterListView,
        resource: constants.resource.filterLists,
      },
      {
        title: 'DEBTIA_TERMINATED_RKI_LIST',
        route: 'rki-normal-list',
        action: constants.action.permissionManualRkiRegistration,
        resource: constants.resource.user,
      },
    ],
  },
]
